module.exports = __webpack_public_path__ + "static/img/di3.03b1f5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/di3.png
// module id = n7IR
// module chunks = 1